import { render, staticRenderFns } from "./ElderlyRateDetail.vue?vue&type=template&id=527b6244&"
import script from "./ElderlyRateDetail.vue?vue&type=script&lang=js&"
export * from "./ElderlyRateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports